import React from 'react'
import { SizableText, SmartLink, YStack, Container, Stack, TextLink } from '@my/ui'
import { KeyboardAwareScrollView, Logo, MainLayout, Meta } from 'app/components'
import { ForgotPasswordFormValues, ForgotPasswordForm } from './components'

export interface ForgotPasswordScreenProps {
  loading: boolean
  completed: boolean
  error?: string
  onSubmit: (values: ForgotPasswordFormValues) => void
}

export const ForgotPasswordScreen = (props: ForgotPasswordScreenProps) => {
  return (
    <MainLayout>
      <Meta title="Forgot password" />

      <KeyboardAwareScrollView style={{ flex: 1 }}>
        <Container gap="$3" flexGrow={1} size="xs" ai="center" jc="flex-start" spaceTop spaceBottom gutter>
          <Logo my="$3.5" width={90} />
          <YStack gap="$4" jc="flex-start" ai="center" w="100%">
            <SizableText textAlign="center" size="$7" fow="600">
              Forgot password
            </SizableText>
            {props.completed ? (
              <SizableText textAlign="center" size="$6">
                We've sent you an email with a link to reset your password. If you don't see it,
                check your spam folder.
              </SizableText>
            ) : (
              <ForgotPasswordForm
                loading={props.loading}
                error={props.error}
                onSubmit={props.onSubmit}
              />
            )}
            <YStack gap="$1" ai="center" pt="$2">
              <SizableText fow="400">
                Don't have an account?{' '}
                <TextLink fow="600" href="/sign-up">
                  Sign up
                </TextLink>
              </SizableText>
            </YStack>
          </YStack>
        </Container>
      </KeyboardAwareScrollView>
    </MainLayout>
  )
}
